import { render, staticRenderFns } from "./bindChart.vue?vue&type=template&id=5ea2542b&scoped=true&"
import script from "./bindChart.vue?vue&type=script&lang=js&"
export * from "./bindChart.vue?vue&type=script&lang=js&"
import style0 from "./bindChart.vue?vue&type=style&index=0&id=5ea2542b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea2542b",
  null
  
)

export default component.exports